/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BidirectionalActionDetails } from './BidirectionalActionDetails';
import {
    BidirectionalActionDetailsFromJSON,
    BidirectionalActionDetailsFromJSONTyped,
    BidirectionalActionDetailsToJSON,
} from './BidirectionalActionDetails';

/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequest
 */
export interface UpdateLeadDecisionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequest
     */
    status_id: string;
    /**
     * 
     * @type {BidirectionalActionDetails}
     * @memberof UpdateLeadDecisionRequest
     */
    bidirectional_action_details?: BidirectionalActionDetails;
}

/**
 * Check if a given object implements the UpdateLeadDecisionRequest interface.
 */
export function instanceOfUpdateLeadDecisionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status_id" in value;

    return isInstance;
}

export function UpdateLeadDecisionRequestFromJSON(json: any): UpdateLeadDecisionRequest {
    return UpdateLeadDecisionRequestFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_id': json['status_id'],
        'bidirectional_action_details': !exists(json, 'bidirectional_action_details') ? undefined : BidirectionalActionDetailsFromJSON(json['bidirectional_action_details']),
    };
}

export function UpdateLeadDecisionRequestToJSON(value?: UpdateLeadDecisionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_id': value.status_id,
        'bidirectional_action_details': BidirectionalActionDetailsToJSON(value.bidirectional_action_details),
    };
}

